import { QueryClient } from "@tanstack/react-query";
import { shouldRetryQuery } from "./query-retry";

/**
 * The app-wide QueryClient, extracted from App.tsx (#1265) so non-component
 * code — the #769 auto-reload busy probe above all — can ask "is any mutation
 * in flight?" without importing the App module (which would cycle:
 * App → use-version-check → app-busy → App).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: shouldRetryQuery, // #3319: faults once, never a 4xx
    },
  },
});
